import {
  ThermostatConstants,
  ThermostatReducer,
  ThermostatActionTypes,
  Thermostat,
  ThermostatFilterCount,
  PollResult,
} from './types';

export const initialState: ThermostatReducer = {
  newRegisteredThermostat: undefined,
  refreshedPin: undefined,
  allThermostats: [],
  allThermostatsCount: 0,
  error: undefined,
  isFetching: false,
  refreshingPin: false,
  isRegistering: false,
  isRestoring: false,
  restoreMessage: undefined,
  thermostatFilters: {
    connection_state: {},
    demand: {},
    direction: {},
    fan_mode: {},
    building_section: {},
    mode: {},
    searchValue: '',
    state: {},
  },
  numberOfFilters: 0,
  poll: {
    success: false,
    should_poll: false,
  },
  filteredThermostats: [],
  filteredThermostatCount: 0,
  thermostatFilterCounts: {
    mode: {
      auto: 0,
      auxHeatOnly: 0,
      cool: 0,
      eco: 0,
      heat: 0,
      heat_cool: 0,
      off: 0,
    },
    fan_mode: {
      auto: 0,
      off: 0,
      on: 0,
    },
    connection_state: {
      offline: 0,
      online: 0,
      reset: 0,
    },
    state: {
      aux_heat: 0,
      cool: 0,
      heat: 0,
      off: 0,
    },
    demand: {
      is_fan_running: 0,
      is_occupied: 0,
    },
  },
};

export function thermostatReducer(state: ThermostatReducer = initialState, action: ThermostatActionTypes) {
  switch (action.type) {
    case ThermostatConstants.RequestNewThermostat:
      return {
        ...state,
        error: undefined,
        isRegistering: true,
      };
    case ThermostatConstants.ReceiveNewThermostat:
      return {
        ...state,
        newRegisteredThermostat: action.payload,
        isRegistering: false,
      };
    case ThermostatConstants.RequestNewPin:
      return {
        ...state,
        refreshingPin: true,
      };
    case ThermostatConstants.ReceiveNewPin:
      return {
        ...state,
        refreshedPin: action.payload,
        refreshingPin: false,
      };
    case ThermostatConstants.ClearRefreshedPin:
      return {
        ...state,
        refreshedPin: undefined,
      };
    case ThermostatConstants.RequestThermostats:
      return {
        ...state,
        isFetching: true,
      };
    case ThermostatConstants.ReceiveThermostats:
      const allThermostats: Array<Thermostat> = action.payload as Array<Thermostat>;
      return {
        ...state,
        isFetching: false,
        allThermostats,
        allThermostatsCount: allThermostats.length,
        error: undefined,
      };
    case ThermostatConstants.ThermostatError:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    case ThermostatConstants.RestoreDefaults:
      return {
        ...state,
        isRestoring: true,
      };
    case ThermostatConstants.SetRestoreMessage:
      return {
        ...state,
        restoreMessage: action.payload,
        isRestoring: false,
      };
    case ThermostatConstants.ClearRestoreResults:
      return {
        ...state,
        restoreMessage: undefined,
        error: undefined,
      };
    case ThermostatConstants.ClearThermostatError:
      return {
        ...state,
        error: undefined,
      };
    case ThermostatConstants.UpdateFilters:
      return {
        ...state,
        thermostatFilters: action.payload,
      };
    case ThermostatConstants.UpdateNumberOfFilters:
      return {
        ...state,
        numberOfFilters: action.payload,
      };
    case ThermostatConstants.UpdateFilteredThermostats:
      const filteredThermostats: Array<Thermostat> = action.payload as Array<Thermostat>;

      return {
        ...state,
        filteredThermostats,
        filteredThermostatCount: filteredThermostats.length,
      };
    case ThermostatConstants.UpdateFilterCounts:
      const thermostatFilterCounts: ThermostatFilterCount = action.payload as ThermostatFilterCount;
      return {
        ...state,
        thermostatFilterCounts: { ...thermostatFilterCounts },
      };
    case ThermostatConstants.PollThermostat:
      const poll: PollResult = action.payload as PollResult;
      return {
        ...state,
        poll: { ...poll },
      };
    case ThermostatConstants.StopRegistering:
      return {
        ...state,
        isRegistering: false,
      };
    default:
      return state;
  }
}
